import { CollapsibleWidgetComponent } from './CollapsibleWidgetComponent';

export function CollapsibleWidgetComponentC(
  props: React.ComponentProps<typeof CollapsibleWidgetComponent>,
) {
  return <CollapsibleWidgetComponent {...props} />;
}
